import React from 'react';

import * as S from './styles';
import { IProps } from './types';
import { Card, Col, Row } from 'react-bootstrap';
import { OrderPaymentDetail, OrderShippingDetail } from '@organisms';
import { OrderItems } from '../OrderItems';
import Alert from '@mui/material/Alert';
import InfoIcon from '@mui/icons-material/Info';
import { OrderStatus } from '../../../../__generated__/globalTypes';
import Typography from '@src/componentsNew/Typography/Typography';

const OrderDetailInformation: React.FC<IProps> = ({ orderByToken }: IProps) => {
  const {
    shippingAddress: address,
    fulfillments,
    discountAmount,
    shippingPrice,
    usedPoint,
    subs,
    voucher,
    totalCaptured,
    number,
    paymentStatus,
    earnPointEvent,
    status,
    isMgs,
  } = orderByToken;
  const codChargeTotal = subs?.reduce((acc, s) => {
    return acc + (s?.codAmount?.amount ?? 0);
  }, 0);

  return (
    <S.Wrapper>
      {paymentStatus === 'CHARGED' && status !== OrderStatus.CANCELED && status !== OrderStatus.DELIVERED ? (
        <div style={{ padding: '0 1rem 1rem', display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          {isMgs && (
            <Row>
              <Col>
                <Alert
                  icon={<InfoIcon />}
                  severity="info"
                  sx={{
                    backgroundColor: '#E500000A',
                    '& .MuiAlert-icon': {
                      color: '#F44336',
                    },
                    '& .MuiAlert-message': {
                      color: '#F44336',
                    },
                  }}
                >
                  <Typography variant="body1" component="p">
                    MGS product will be dispatched from out of India. Delivery may take longer than usual.
                  </Typography>
                </Alert>
              </Col>
            </Row>
          )}

          <Row>
            <Col>
              <Alert
                icon={<InfoIcon />}
                severity="info"
                sx={{
                  backgroundColor: '#E5F6FD',
                  '& .MuiAlert-icon': {
                    color: '#01579B',
                  },
                  '& .MuiAlert-message': {
                    color: '#01579B',
                  },
                }}
              >
                <Typography variant="body1" component="p">
                  Items aren't eligible for cancellation post shipment. For pre shipment cancellation contact
                  support@maccaron.in
                </Typography>
              </Alert>
            </Col>
          </Row>
        </div>
      ) : null}

      <OrderShippingDetail address={address} fulfillments={fulfillments} number={number} />
      {/* 결제 완료 되었을 때 */}
      {paymentStatus === 'CHARGED' ? (
        <OrderPaymentDetail
          discount={discountAmount.amount}
          deliveryCharge={shippingPrice.gross.amount}
          point={usedPoint.amount}
          voucher={voucher}
          subtotal={totalCaptured.amount}
          earnPointAmount={earnPointEvent?.amount ?? 0}
          codChargeTotal={codChargeTotal}
        />
      ) : (
        ''
      )}
      <OrderItems subs={subs} />
    </S.Wrapper>
  );
};

export { OrderDetailInformation };
